module.exports = __webpack_public_path__ + "static/media/thailand-map-on.87eb6681.png";